import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modals';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useApproveTokenMutation,
  useRejectTokenMutation,
} from '../../redux/api/authorized/tokenSubmission';
import { toast } from 'react-toastify';

const TokenSubmissionResponse = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { id, action } = useParams();

  const [rejectToken] = useRejectTokenMutation();
  const [approveToken] = useApproveTokenMutation();

  useEffect(() => {
    if (id) {
      console.log(window.location);
      dispatch(
        openModal({
          name: 'confirmation',
          props: {
            onContinue: async () => {
              const actionHandler =
                action === 'approve' ? approveToken : rejectToken;
              const response = await actionHandler({ id });
              if (response?.error) {
                toast('There was an error.', {
                  type: 'error',
                });
              } else {
                navigate('/');
                toast('Done.', {
                  type: 'success',
                });
              }
            },
            onCancel: () => {
              navigate('/');
            },
            title: action === 'approve' ? 'Approve token' : 'Reject token',
            text:
              action === 'approve'
                ? 'Are you sure you want to approve this token?'
                : 'Are you sure you want to reject this token?',
          },
        }),
      );
    }
  }, [id]);

  return <></>;
};

export default TokenSubmissionResponse;
